/** Stable, stored names for the reusable backgrounds offered by content bands. */
export const BLOCK_BACKGROUND_PALETTES = [
    "transparent",
    "white",
    "light-blue",
];
export const BLOCK_BACKGROUND_PALETTE_KEY = "backgroundPalette";
export const DEFAULT_BLOCK_BACKGROUND_PALETTE = "transparent";
export const BLOCK_BACKGROUND_COLORS = {
    transparent: "#00000000",
    white: "#FFFFFF",
    "light-blue": "#E8F2FA",
};
/** CMS labels and ordering for every block that exposes the shared palette. */
export const BLOCK_BACKGROUND_PALETTE_OPTIONS = [
    { value: "transparent", label: "Transparent", swatch: "#00000000" },
    { value: "white", label: "White", swatch: "#FFFFFF" },
    { value: "light-blue", label: "Light blue", swatch: "#E8F2FA" },
];
/** One schema declaration reused by each authorable block that offers a background. */
export const BLOCK_BACKGROUND_PALETTE_SLOT = {
    key: BLOCK_BACKGROUND_PALETTE_KEY,
    label: "Background color",
    type: "color-palette",
    options: BLOCK_BACKGROUND_PALETTE_OPTIONS,
    defaultValue: DEFAULT_BLOCK_BACKGROUND_PALETTE,
};
/**
 * Resolve stored content defensively. A caller may choose a compatibility
 * fallback for a component that shipped before the field existed.
 */
export function resolveBlockBackgroundPalette(value, fallback = DEFAULT_BLOCK_BACKGROUND_PALETTE) {
    return BLOCK_BACKGROUND_PALETTES.includes(value ?? "")
        ? value
        : fallback;
}
//# sourceMappingURL=background-palette.js.map